<template>
    <div>
        <div class="flex flex-col items-start justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40 text-left">
            <h2 class="self-center mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">Kontakt</h2>
            <p class="mt-2 font-semibold text-lg">
                E-Mail
            </p>
            <a href="mailto:info@markus-holzbach.de">info@markus-holzbach.de</a>
        </div>
    </div>
</template>
<script>
export default {
    props: {},
    data ()
    {
        return {};
    },
    methods: {},
    created () { },
};
</script>